import { Link } from 'react-router-dom';
import '../index.css';

const Product5 = () => {
  const whatsappLink = "https://wa.me/5511964768245?text=Quero%20comprar%20a%20consultoria";

  return (
    <div style={{ background: '#ffffff', minHeight: '100vh' }}>
      {/* Header */}
      <header style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '1rem 0' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 1.5rem' }}>
          <Link to="/produtos" style={{ color: '#1f2937', textDecoration: 'none', fontSize: '0.95rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
            ← Voltar para Produtos
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{ padding: 'clamp(2.5rem, 6vw, 4rem) 1.25rem clamp(2rem, 5vw, 3rem)', maxWidth: 1000, margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 800, color: '#111827', marginBottom: '1rem', lineHeight: 1.2 }}>
          Consultoria Personalizada<br />Sobre Seu Projeto Lovable
        </h1>
        <p style={{ fontSize: 'clamp(1.1rem, 2.5vw, 1.35rem)', color: '#6b7280', maxWidth: 700, margin: '0 auto 2.5rem', lineHeight: 1.6 }}>
          Tire suas dúvidas, receba orientação especializada e descubra o melhor caminho para evitar erros e dor de cabeça no futuro
        </p>
        
        <img 
          src="https://static.lumi.new/00/008c7e14463c3c9f258d310eb422b345.webp" 
          alt="Consultoria Lovable" 
          style={{ 
            width: '100%', 
            maxWidth: 600, 
            borderRadius: 16, 
            margin: '0 auto 2rem',
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
          }} 
        />

        {/* Preço */}
        <div style={{ background: '#f9fafb', padding: '2rem', borderRadius: 16, maxWidth: 500, margin: '0 auto 2rem', border: '1px solid #e5e7eb' }}>
          <p style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Investimento</p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <span style={{ fontSize: '1.5rem', color: '#9ca3af', textDecoration: 'line-through' }}>R$ 499</span>
            <span style={{ fontSize: '3rem', fontWeight: 800, color: '#10b981' }}>R$ 347</span>
          </div>
          <p style={{ fontSize: '1.1rem', color: '#4b5563', marginBottom: '1.5rem' }}>por hora via Google Meet</p>
          
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: '#fff',
              padding: '1.25rem clamp(2rem, 8vw, 3rem)',
              borderRadius: 12,
              fontSize: '1.25rem',
              fontWeight: 700,
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(16, 185, 129, 0.3)',
              transition: 'all 0.3s ease',
              border: 'none',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 30px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(16, 185, 129, 0.3)';
            }}
          >
            💥 QUERO A CONSULTORIA!
          </a>
        </div>
      </section>

      {/* O Que Vamos Abordar */}
      <section style={{ padding: 'clamp(2rem, 5vw, 3rem) 1.25rem', background: '#f9fafb' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', fontWeight: 700, textAlign: 'center', color: '#111827', marginBottom: '3rem' }}>
            O Que Vamos Abordar na Consultoria
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>
            {[
              {
                icon: '🎯',
                title: 'Análise do Seu Projeto',
                desc: 'Revisão completa da estrutura, arquitetura e melhores práticas para seu projeto Lovable'
              },
              {
                icon: '🗄️',
                title: 'Banco de Dados e Supabase',
                desc: 'Estruturação correta de schemas, queries eficientes e integração profissional com Supabase'
              },
              {
                icon: '⚡',
                title: 'Performance e Otimização',
                desc: 'Identificação de gargalos, otimização de código e melhorias para seu app rodar mais rápido'
              },
              {
                icon: '🛡️',
                title: 'Segurança e Boas Práticas',
                desc: 'Implementação de autenticação, autorização e padrões de segurança essenciais'
              },
              {
                icon: '🚀',
                title: 'Deploy e Produção',
                desc: 'Estratégias para colocar seu projeto no ar com estabilidade e escalabilidade'
              },
              {
                icon: '💡',
                title: 'Solução de Problemas',
                desc: 'Resolução de bugs, erros e dúvidas técnicas que estão travando seu desenvolvimento'
              }
            ].map((item, idx) => (
              <div key={idx} style={{ background: '#fff', padding: '2rem', borderRadius: 12, border: '1px solid #e5e7eb', transition: 'all 0.3s ease' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{item.icon}</div>
                <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#111827', marginBottom: '0.75rem' }}>{item.title}</h3>
                <p style={{ fontSize: '1rem', color: '#6b7280', lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Para Quem É */}
      <section style={{ padding: 'clamp(2rem, 5vw, 3rem) 1.25rem' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', fontWeight: 700, textAlign: 'center', color: '#111827', marginBottom: '2rem' }}>
            Para Quem É Esta Consultoria
          </h2>
          
          <div style={{ background: '#f9fafb', padding: '2.5rem', borderRadius: 16, border: '1px solid #e5e7eb' }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                'Desenvolvedores que estão começando com Lovable e precisam de direcionamento',
                'Projetos travados por erros técnicos ou dúvidas sobre arquitetura',
                'Quem quer migrar do Lovable Cloud para Supabase com segurança',
                'Empreendedores construindo MVPs e precisam validar a estrutura técnica',
                'Desenvolvedores que querem aprender as melhores práticas e evitar retrabalho',
                'Projetos que precisam de revisão de código e otimização de performance'
              ].map((item, idx) => (
                <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1.25rem', fontSize: '1.1rem', color: '#374151' }}>
                  <span style={{ color: '#10b981', fontSize: '1.5rem', flexShrink: 0 }}>✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Como Funciona */}
      <section style={{ padding: 'clamp(2rem, 5vw, 3rem) 1.25rem', background: '#f9fafb' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', fontWeight: 700, color: '#111827', marginBottom: '2rem' }}>
            Como Funciona
          </h2>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', textAlign: 'left' }}>
            {[
              { num: '1', title: 'Entre em Contato', desc: 'Clique no botão e envie uma mensagem no WhatsApp' },
              { num: '2', title: 'Agendamento', desc: 'Vamos agendar o melhor horário para a chamada no Google Meet' },
              { num: '3', title: 'Preparação', desc: 'Me envie detalhes do seu projeto e principais dúvidas' },
              { num: '4', title: 'Consultoria', desc: 'Sessão de 1 hora focada em resolver seus problemas e orientar seu projeto' },
              { num: '5', title: 'Material de Apoio', desc: 'Após a consultoria, você recebe um resumo com as principais orientações' }
            ].map((step, idx) => (
              <div key={idx} style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start', background: '#fff', padding: '1.5rem', borderRadius: 12, border: '1px solid #e5e7eb' }}>
                <div style={{ 
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
                  color: '#fff', 
                  width: 48, 
                  height: 48, 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  fontSize: '1.5rem', 
                  fontWeight: 700,
                  flexShrink: 0
                }}>
                  {step.num}
                </div>
                <div>
                  <h3 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', marginBottom: '0.5rem' }}>{step.title}</h3>
                  <p style={{ fontSize: '1rem', color: '#6b7280', margin: 0 }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section style={{ padding: 'clamp(2.5rem, 6vw, 4rem) 1.25rem', textAlign: 'center' }}>
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(1.75rem, 4vw, 2.5rem)', fontWeight: 700, color: '#111827', marginBottom: '1rem' }}>
            Pronto Para Turbinar Seu Projeto?
          </h2>
          <p style={{ fontSize: '1.2rem', color: '#6b7280', marginBottom: '2rem', lineHeight: 1.6 }}>
            Não perca mais tempo travado. Vamos resolver suas dúvidas e colocar seu projeto no caminho certo.
          </p>
          
          <div style={{ background: '#f9fafb', padding: '2rem', borderRadius: 16, marginBottom: '2rem', border: '1px solid #e5e7eb' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginBottom: '0.5rem' }}>
              <span style={{ fontSize: '1.25rem', color: '#9ca3af', textDecoration: 'line-through' }}>R$ 499</span>
              <span style={{ fontSize: '2.5rem', fontWeight: 800, color: '#10b981' }}>R$ 347</span>
            </div>
            <p style={{ fontSize: '1rem', color: '#6b7280' }}>por hora via Google Meet</p>
          </div>

          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
              color: '#fff',
              padding: '1.25rem 3rem',
              borderRadius: 12,
              fontSize: '1.25rem',
              fontWeight: 700,
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(16, 185, 129, 0.3)',
              transition: 'all 0.3s ease',
              border: 'none',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 30px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(16, 185, 129, 0.3)';
            }}
          >
            💥 GARANTIR MINHA CONSULTORIA AGORA
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ background: '#111827', color: '#9ca3af', padding: 'clamp(1.5rem, 4vw, 2rem) 1.25rem', textAlign: 'center' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <p style={{ margin: 0, fontSize: '0.95rem' }}>© 2026 Extensão Lovable Ilimitado - Todos os direitos reservados</p>
        </div>
      </footer>
    </div>
  );
};

export default Product5;
